import React from 'react'
import {Button, Tooltip, IconButton} from '@material-ui/core';

import {useStyles} from "./styles";
import { MuiThemeProvider } from '@material-ui/core/styles'
import { buttonTheme } from '../../../shared/colors'

export default function AppButton(props){
    const {
            size = 'small',
            placement = 'left',
            disableTooltip = false,
            text='',
            tooltip='',
            icon,
            className,
            onClick,
            disabled=false,
            type='icon-button',
            buttonStyle,
            buttonProps,
            variant='contained',
            label,
            ...wrapperProps
        } = props

    const classes = useStyles({type})

    const commonProps = {
        size,
        disabled,
        onClick,
        color: 'primary',
        "aria-label": label,
        style: {...buttonStyle},
        className: classes[className],
        ...buttonProps
    }

    return(
        <div
            {...wrapperProps} id={`${wrapperProps.id}_${Math.floor(Math.random()*(50000-2 +1) + 2)}`}
            style={{width: 'fit-content', ...wrapperProps.style}}
        >
            <Tooltip
                title={tooltip}
                placement={placement}
                disableHoverListener={disableTooltip}
            >
                <span>
                    { type === 'icon-only' &&
                        <IconButton {...commonProps} >
                            {icon}
                        </IconButton>
                    }
                    { type === 'icon-button' &&
                        <MuiThemeProvider theme={buttonTheme}>
                            <Button
                                disableRipple
                                {...commonProps}
                                variant={variant}
                                startIcon={icon}
                            >
                                {text}
                            </Button>
                        </MuiThemeProvider>
                    }
                </span>
            </Tooltip>
        </div>

    )
}
